import { dataTrackFrameLast } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTrackFrameLast = /*#__PURE__*/createIcon(dataTrackFrameLast)
export default IconTrackFrameLast
